import React from 'react';
import { compose } from 'ramda';

import {  Button } from '@synergycms_core/components/generic';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './newAvailButton.js';
import { validateAsyncComponent } from '../../HoC';
import connect from 'react-redux/es/connect/connect';
import actions from '../../../store/actions';
import { Map } from 'immutable';
import moment from 'moment';
import { showPopover } from '@synergycms_core/components/providers/popoverProvider.jsx';


const NewAvailButton = class NewAvailButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  static displayName = 'NewAvailButton';

  handleClick = (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();

    // props pueden venir en this.props o en this.props.config (PropertyManager)
    const config = this.props.config || {};
    const dates = this.props.dates || config.dates;
    const start = dates && dates.start;
    const end = dates && dates.end;

    const baseDate = this.props.date || config.date;
    const baseEnd = this.props.dateEnd || config.dateEnd;

    // función para refrescar disponibilidad (inyectada en config por mergeProps)
    const getNewAvailDay = this.props.getNewAvailDay || config.getNewAvailDay;

    // comparador
    const startChanged = start && baseDate && !moment(start).isSame(moment(baseDate), 'day');
    const endChanged = end && baseEnd && !moment(end).isSame(moment(baseEnd), 'day');

    if (startChanged || endChanged) {
      if (typeof getNewAvailDay === 'function') {
        getNewAvailDay(e);
      }
    } else {
      // mismas fechas: cerrar. Preferimos callback pasado por el padre (onSameDateSelected)
      const onSame = this.props.onSameDateSelected || config.onSameDateSelected;
      if (typeof onSame === 'function') {
        onSame(e);
      } else {
        // fallback: intentar toggleModal
        const toggle = this.props.toggleModal || config.toggleModal;
        if (typeof toggle === 'function') {
          toggle(false, 'calendarModal');
        }
      }
    }

    // limpiar overflow si el datepicker había bloqueado el scroll
    try {
      if (document && document.body && document.body.style && document.body.style.overflow === 'hidden') {
        document.body.style.overflow = '';
      }
    } catch (err) {
      // no hacemos nada si por alguna razón document no está disponible
    }
  };


  render() {
    const { theme } = this.props;
    const { classes } = theme.styles;

    return (
      <div className={[theme.computedInnerStyle, classes.dateChangeButton].join(' ')}>
        <Button onClick={this.handleClick} innerStyle={'toggleMainButton'} ariaLabel={'_%cambiar fechas%_'} richText={{plural: true,text: '_%cambiar fechas%_',ucFirst: true,innerStyle: ['toggleMainButton'],translate: true}}>
        </Button>
      </div>
    );
  }
};



const mapDispatchToProps = dispatch => {
  return {
    getNewAvailDay: (baseDate, baseEnd, datepickerDates, room) => (e) => {
      const start = datepickerDates && datepickerDates.start;
      const end = datepickerDates && datepickerDates.end;
      if ((start && baseDate !== start) || (end && baseEnd !== end)) {

        dispatch(
          actions.customer.params.updateParams(
            Map({
              date: datepickerDates.start,
              stay_length: moment(datepickerDates.end).diff(moment(datepickerDates.start), 'd', true),
              room_id: ((room && room.get("id")) || null)
            })
          )
        );

        dispatch(actions.router.update(true));
        setTimeout(function () {
          window.scrollTo(0, 0);
        }, 300);
      }
    }
  };
};
const mapStateToProps = store => {
  const date = store.getIn(['customer', 'params', 'params', 'date']);
  const dateEnd = store.getIn(['customer', 'params', 'url_params', 'end']);
  return {
    date,
    dateEnd
  };
};
const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    getNewAvailDay: dispatchProps.getNewAvailDay(stateProps.date, stateProps.dateEnd, ownProps.dates, ownProps.room)
  });
};

export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  ),
  PropertyManager(['getNewAvailDay', 'date', 'dateEnd', 'room', 'dates', 'toggleModal', 'onSameDateSelected']),
  showPopover,
  withThemeJSS({ styleFile, link: true })
)(NewAvailButton);
